import { FC } from 'react';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { useTheme } from '@mui/material/styles';
const SubmittingButton: FC<LoadingButtonProps> = ({ children, loading, ...props }) => {

  const theme = useTheme();
  return (
    <LoadingButton
      type='submit'
      variant='contained'
      loadingPosition='start'
      loading={loading}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(1),
        minWidth: '130px',
        minHeight: '50px',
        maxHeight: '50px',
        color: '#fff',
        border: '1px solid #fff',
        '&:hover': {
          //    background: 'transparent',
          '& .button-content': {
            background: theme.palette.secondary.main,
          },
        },
        '&.Mui-disabled': {
         // background: 'transparent',
          color: 'gray',
          '& .button-content': {
           // background: theme.palette.secondary.main,
          },
        },
      }}
      {...props}
    >
      <p className='h-full w-full flex-grow inline-flex items-center justify-center  button-content rounded-[4px]  '>
        {children}
      </p>

    </LoadingButton>
  );
};

export default SubmittingButton;
